import { Injectable } from '@angular/core';
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BrandStateService {

  private changeSource = new Subject<boolean>();

  brandStateChanged$ = this.changeSource.asObservable();

  constructor() {
  }

  brandStateChanged(brandStateChanged: boolean) {
    this.changeSource.next(brandStateChanged);
  }
}
